const ITEMS = [
  "Food Grade FIBC Inks",
  "Heat Resistant Cement Bag Inks",
  "Tape Tested Fertilizer Inks",
  "Extrusion Lamination",
  "Reverse Lamination",
  "Gravure",
  "Metallic",
  "Woven Sack",
  "Est. 1997 · Kanpur",
];

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="overflow-hidden border-y border-black bg-[#0B0B0B] py-6 md:py-8">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
          {ITEMS.map((t, i) => (
            <span key={i} className="flex items-center">
              <span className={`font-wide whitespace-nowrap px-6 text-3xl font-black uppercase tracking-tight md:px-10 md:text-6xl ${i % 3 === 1 ? "text-transparent [-webkit-text-stroke:1.5px_#FAFAF7]" : "text-[#FAFAF7]"}`}>
                {t}
              </span>
              <span className={`h-3 w-3 shrink-0 rounded-full md:h-4 md:w-4 ${i % 2 ? "bg-[#FF5A00]" : "bg-[#FFC400]"}`} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
